import { Outlet } from "@tanstack/react-router";
import { ProDriverLayoutHeader } from "@/app/ProDrivers/Common/components/ProDriverLayoutHeader";
import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";

export function ProDriverLayout() {
  return (
    <FullPageScreen>
      <ProDriverLayoutHeader />
      <Outlet />
    </FullPageScreen>
  );
}
